
<div class="so-card" @click.stop="navigate(item.id)">
  <div class="socard-header" :class="occurrenceClass">
    <div class="d-flex align-items-center">
      <div>
        <i class="far fa-star mr-1" />
      </div>
      <div class="flex-grow-1">
        <div class="d-flex align-items-center justify-content-between">
          <div>{{ typeName }}</div>
          <div class="d-flex align-items-center">
            <div v-if="item.linkedMaterialRequestId">
              <button class="badge badgebutton mr-2" v-b-tooltip="'Go to Material Request'" @click.stop="navigate(item.linkedMaterialRequestId)">MatReq</button>
            </div>
            <div v-if="item.aircraftRegistration" class="badge badgebutton active" :id="item.id">
              <i class="far fa-plane text-white" />
              {{ item.aircraftRegistration }}
            </div>
          </div>
        </div>
        <div class="">{{item.name}}</div>
      </div>
      </div>
    </div>
</div>
